import * as React from 'react'
import clx from 'classnames'
import { FaIcon, faEye, faEyeSlash } from '@/lib/fa'

type Props = {
  label?: string
  value?: string
  name?: string
  placeholder?: string
  error?: string | boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  disabled?: boolean
  required?: boolean
  type?: React.HTMLInputTypeAttribute
  min?: number
  max?: number
  step?: number
  suffix?: string
  wrapperClassName?: string
  bottomInfo?: string | React.ReactNode
}

export const FieldsetInput = ({
  label,
  value,
  name,
  placeholder,
  onChange,
  error,
  className,
  disabled = false,
  required = false,
  type = 'text',
  min,
  max,
  step,
  suffix,
  wrapperClassName,
  bottomInfo,
}: Props) => {
  const hasError = Boolean(error)
  const isPasswordType = type === 'password'

  const [parsedType, setParsedType] = React.useState<string>(type)

  return (
    <fieldset className={clx('tw-d-form-control tw-w-full', wrapperClassName)}>
      {label && (
        <label className="tw-mb-0 tw-px-1 tw-pb-0.5 tw-text-sm tw-font-medium">
          {required && <span className="tw-mr-0.5 tw-text-error">*</span>}
          {label}
        </label>
      )}
      <span
        className={clx(
          `tw-d-input tw-d-input-sm tw-d-input-primary tw-relative tw-flex tw-h-9 tw-items-center tw-gap-2 tw-rounded-[4px] tw-border-content-base/20 !tw-px-3 focus-within:!tw-border-content-base/20 focus-within:!tw-text-content-base ${disabled ? 'tw-text-content-base/30' : 'tw-text-input'}`,
          className,
          {
            '[&:not(:focus-within)]:tw-d-input-error': hasError,
            '!tw-border-base-200 !tw-bg-base-200': disabled,
          },
        )}
      >
        <input
          className={clx('tw-peer tw-w-full', {})}
          value={value || ''}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          type={parsedType}
          min={min}
          max={max}
          step={step}
          required={required}
        />
        {isPasswordType && (
          <div className="tw-relative tw-z-20 tw-cursor-pointer">
            {parsedType === 'password' ? (
              <FaIcon icon={faEye} onClick={() => setParsedType('text')} />
            ) : (
              <FaIcon
                icon={faEyeSlash}
                onClick={() => setParsedType('password')}
              />
            )}
          </div>
        )}
        {suffix && <span>{suffix}</span>}
      </span>

      {bottomInfo && typeof bottomInfo === 'string' ? (
        <p className="tw-my-2 tw-p-1 tw-text-sm tw-text-neutral">
          {bottomInfo}
        </p>
      ) : bottomInfo ? (
        bottomInfo
      ) : null}

      {hasError && typeof error === 'string' && (
        <span className="tw-text-xs tw-font-medium tw-text-error peer-focus-within:tw-opacity-0">
          {error}
        </span>
      )}
    </fieldset>
  )
}
